module.exports = window["MaterialUI"].Chip;